module.exports = __webpack_public_path__ + "img/jurkiewicz_gbs.a38d5216.png";